module.exports = __webpack_public_path__ + "assets/img/news (12).73b5b5d5.png";